/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Company_PhoneInputs */

const vi_sinp_company_phone = /** @type {(inputs: Sinp_Company_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐT`)
};

/**

* @param {Sinp_Company_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_company_phone = /** @type {((inputs?: Sinp_Company_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Company_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_company_phone(inputs)
});